<template>
    <span>
        <span class="text-success">
            <i
                class="fa fa-plus-circle fa-lg icon-button"
                title="Adicionar Destinatário"
                @click.stop="abrir()"
            ></i>
        </span>
        <b-modal v-model="mostrarModal" @show="obterDestinatarios()">
            <div slot="modal-title">Selecionar Destinatário</div>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <model-list-select
                            :list="destinatarios"
                            option-text="nome"
                            option-value="email"
                            v-model="destinatario"
                        >
                        </model-list-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fechar()"
                    >Fechar</b-button
                >
                <b-button
                    variant="primary"
                    :disabled="$v.$invalid"
                    @click.stop="adicionarDestinatario()"
                    class="ml-2"
                >
                    <span>
                        <i class="fa fa-plus-circle"></i> Adicionar
                        Destinatário</span
                    >
                </b-button>
            </div>
        </b-modal>
    </span>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import RequisicoesServicos from './RequisicoesServicos'
import { ModelListSelect } from 'vue-search-select'

export default {
    data() {
        return {
            mostrarModal: false,
            destinatarios: [],
            destinatario: null
        }
    },

    components: {
        ModelListSelect
    },

    methods: {
        abrir() {
            this.mostrarModal = true
        },

        fechar() {
            this.mostrarModal = false
            this.destinatarios = []
            this.destinatario = null
        },

        obterDestinatarios() {
            this.$store.dispatch('addRequest')
            RequisicoesServicos.obterDestinatarios(
                this.$route.params.idRequisicao
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.destinatarios = response.data
                        this.destinatario = this.destinatarios[0].email
                    } else {
                        this.$toast.error(
                            'Erro ao obter destinatários!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        adicionarDestinatario() {
            this.$emit('adicionarDestinatario', this.destinatario)
            this.fechar()
        }
    },

    computed: {},

    created() {},

    watch: {},

    validations: {
        destinatario: {
            required
        }
    }
}
</script>
